import { isDefined } from "@timeedit/registration-shared";
import { CalendarEvent } from "../../../../utils/events";

export type EventWithRelated = {
  event: CalendarEvent;
  relatedEvents: CalendarEvent[];
};

type CreateActivityEventsProps = {
  eventsWithRelated: Partial<EventWithRelated>[];
};
export function createActivityEvents({
  eventsWithRelated,
}: CreateActivityEventsProps): CalendarEvent[] {
  return eventsWithRelated.reduce<CalendarEvent[]>((addedEvents, curr) => {
    const currentEvent = curr.event;
    if (!isDefined(currentEvent)) return addedEvents;
    const eventsToAdd = [currentEvent, ...(curr.relatedEvents ?? [])].filter(
      (event) => !addedEvents.some((addedEvent) => addedEvent.id === event.id)
    );

    return [...addedEvents, ...eventsToAdd];
  }, []);
}
